import React, { useState } from "react";
import { Button, Form, Container, Alert } from "react-bootstrap";

const BalanceSheetComponent = () => {
  const [mobile, setMobile] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const validateMobile = (value) => {
    const mobileRegex = /^[0-9]{10}$/; // Validates 10-digit numbers
    return mobileRegex.test(value);
  };

  const handleChange = (e) => {
    const value = e.target.value;
    if (value === "" || validateMobile(value)) {
      setErrorMessage("");
    } else {
      setErrorMessage("Please enter a valid 10-digit mobile number.");
    }
    setMobile(value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateMobile(mobile)) {
      setErrorMessage("Please enter a valid 10-digit mobile number.");
      return;
    }
    console.log("Mobile number submitted:", mobile);
    setShowAlert(true);
    setTimeout(() => setShowAlert(false), 3000); // Hide alert after 3 seconds
    setMobile(""); // Clear input
  };

  return (
    <Container className="mt-5">
      <div className="row">
        <div className="col-md-4">
          {/* Form Section */}
          <div className="p-4 shadow rounded bg-light">
            <h5 className="mb-4">Balance Sheet</h5> {/* Reduced Heading Size */}

            {/* Success Alert */}
            {showAlert && (
              <Alert variant="success" className="text-center">
                Mobile number submitted successfully!
              </Alert>
            )}

            {/* Balance Sheet Form */}
            <Form onSubmit={handleSubmit} noValidate>
              <Form.Group controlId="formMobile" className="mb-3">
                <Form.Label>Mobile Number</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter 10-digit Mobile Number"
                  value={mobile}
                  onChange={handleChange}
                  isInvalid={!!errorMessage}
                  required
                />
                <Form.Control.Feedback type="invalid">
                  {errorMessage}
                </Form.Control.Feedback>
              </Form.Group>

              <div className="d-flex justify-content-end">
                <Button
                  variant="primary"
                  type="submit"
                  className="px-4"
                  disabled={!mobile || !!errorMessage}
                >
                  Submit
                </Button>
              </div>
            </Form>
          </div>
        </div>

        <div className="col-md-8 d-none d-md-block">
          {/* Placeholder for additional content or empty space */}
          <div className="bg-light h-100 rounded shadow-sm"></div>
        </div>
      </div>
    </Container>
  );
};

export default BalanceSheetComponent;
